module.exports = __webpack_public_path__ + "img/phone1.1008d1e6.png";